import ColorHelper from "./colorHelper"

export default class GeneralHelper
{

 static storage(cx = false) {
  if (cx) {
    return Cx.Storage;
  }
  //need more space than 5MBs
  else {
      var s ;
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        // We've got the real thing! Return its response.
        s = navigator.storage;
      }
      else if ('webkitTemporaryStorage' in navigator && 'queryUsageAndQuota' in navigator.webkitTemporaryStorage) {
        s = navigator.webkitTemporaryStorage ;
      }
      return {
        setObject: function(key, val) {

        }
        , getObject: function(key) {

        }
      }
    }
  }

  static errorOut( msg ) {
    if( window.PatternBuilder.config().MODALERROR )
      $('#error-msg').html(msg);
    else
      console.log(msg);
  }

  static log (msg) { console.log(msg); }

  static reset_CUSTOMER_HASH() {
    window.AppInstance.instance().CUSTOMER_HASH = null ;
    window.AppInstance.instance().SHOPPERID = null ;
  }
  
  static is_user_logged_in() {
    return ( window.AppInstance.instance().CUSTOMER_HASH !== null && ( window.AppInstance.instance().CUSTOMER_HASH.length > 0 ) )
    && ( window.AppInstance.instance().SHOPPERID !== null && ( window.AppInstance.instance().SHOPPERID.length > 0 ) );
  }

  static color_set_length(cs)
  {
    var n = 0 ;
    for ( var key in cs )
        n++;
    return n;
  }

  static get_query_string(key)
  {
      var l = location.search.match(new RegExp(key + "=(.*?)($|\&)", "i")) ;
      return ( ( l != null ) ? l[1] : null );
  };

  static getPatternContainersFromLocalStorage(container, hash){
    if(Cx.Storage.isAvailable()){
      return GeneralHelper.storage(true).getObject('cxpatternbuilder.' +container +'.' + hash);
    }
  };

  static savePatternContainersToLocalStorage(container, hash, patternContainers){
    if(Cx.Storage.isAvailable()){
      let key = 'cxpatternbuilder.' +container +'.' + hash ;
      try {
        GeneralHelper.storage(true).setObject(key, patternContainers);
        GeneralHelper.storage(true).setObject(key+"-timestamp", Date.now().toString());
      }
      catch(e) {
        localStorage.clear();
      }
    }
  };

  static M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}
  static X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}
  static V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}
  static Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=GeneralHelper.md5_ii(f=GeneralHelper.md5_ii(f=GeneralHelper.md5_ii(f=GeneralHelper.md5_ii(f=GeneralHelper.md5_hh(f=GeneralHelper.md5_hh(f=GeneralHelper.md5_hh(f=GeneralHelper.md5_hh(f=GeneralHelper.md5_gg(f=GeneralHelper.md5_gg(f=GeneralHelper.md5_gg(f=GeneralHelper.md5_gg(f=GeneralHelper.md5_ff(f=GeneralHelper.md5_ff(f=GeneralHelper.md5_ff(f=GeneralHelper.md5_ff(f,r=GeneralHelper.md5_ff(r,i=GeneralHelper.md5_ff(i,m=GeneralHelper.md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=GeneralHelper.md5_ff(r,i=GeneralHelper.md5_ff(i,m=GeneralHelper.md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=GeneralHelper.md5_ff(r,i=GeneralHelper.md5_ff(i,m=GeneralHelper.md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=GeneralHelper.md5_ff(r,i=GeneralHelper.md5_ff(i,m=GeneralHelper.md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=GeneralHelper.md5_gg(r,i=GeneralHelper.md5_gg(i,m=GeneralHelper.md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=GeneralHelper.md5_gg(r,i=GeneralHelper.md5_gg(i,m=GeneralHelper.md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=GeneralHelper.md5_gg(r,i=GeneralHelper.md5_gg(i,m=GeneralHelper.md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=GeneralHelper.md5_gg(r,i=GeneralHelper.md5_gg(i,m=GeneralHelper.md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=GeneralHelper.md5_hh(r,i=GeneralHelper.md5_hh(i,m=GeneralHelper.md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=GeneralHelper.md5_hh(r,i=GeneralHelper.md5_hh(i,m=GeneralHelper.md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=GeneralHelper.md5_hh(r,i=GeneralHelper.md5_hh(i,m=GeneralHelper.md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=GeneralHelper.md5_hh(r,i=GeneralHelper.md5_hh(i,m=GeneralHelper.md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=GeneralHelper.md5_ii(r,i=GeneralHelper.md5_ii(i,m=GeneralHelper.md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=GeneralHelper.md5_ii(r,i=GeneralHelper.md5_ii(i,m=GeneralHelper.md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=GeneralHelper.md5_ii(r,i=GeneralHelper.md5_ii(i,m=GeneralHelper.md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=GeneralHelper.md5_ii(r,i=GeneralHelper.md5_ii(i,m=GeneralHelper.md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=GeneralHelper.safe_add(m,h),f=GeneralHelper.safe_add(f,t),r=GeneralHelper.safe_add(r,g),i=GeneralHelper.safe_add(i,e)}return Array(m,f,r,i)}
  static md5_cmn(d,_,m,f,r,i){return GeneralHelper.safe_add(GeneralHelper.bit_rol(GeneralHelper.safe_add(GeneralHelper.safe_add(_,d),GeneralHelper.safe_add(f,i)),r),m)} static md5_ff(d,_,m,f,r,i,n){return GeneralHelper.md5_cmn(_&m|~_&f,d,_,r,i,n)} static md5_gg(d,_,m,f,r,i,n){return GeneralHelper.md5_cmn(_&f|m&~f,d,_,r,i,n)} static md5_hh(d,_,m,f,r,i,n){return GeneralHelper.md5_cmn(_^m^f,d,_,r,i,n)} static md5_ii(d,_,m,f,r,i,n){return GeneralHelper.md5_cmn(m^(_|~f),d,_,r,i,n)} static safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m} static bit_rol(d,_){return d<<_|d>>>32-_};

  static md5Encode(d){ let result = GeneralHelper.M(GeneralHelper.V(GeneralHelper.Y(GeneralHelper.X(d),8*d.length)));return result.toLowerCase()};

  static has_valid_tags ( tags, match )
    {
      var count_valid = 0 ;
      
      Cx_.forEach(tags, function(t) {
          count_valid += ( t.Name.toUpperCase().indexOf(match.toUpperCase()) > -1 ) ;
      });
      return  ( count_valid > 0 ) ;
    };

    static get_display_order_value (cdl)
    {
      var order = Number.MAX_SAFE_INTEGER ;
      var search = "DisplayOrder" ;
      var start_pos = cdl.indexOf(search);
      if ( start_pos > -1 )
      {
        cdl = cdl.substring(start_pos+search.length+2, cdl.length-1),
        cdl = cdl.substring(0, cdl.indexOf('"'));
        if (cdl.length > 0)
            order = parseInt(cdl);
      }
      return order;
    };

    static change_swatch( picker, hex, name)
    {
      if (name.length == 0)
        name = ColorHelper.hexaToNameFindAny(hex);
      $(picker).find(".pattern-color")[0].setAttribute("style", "background-color: #"+hex+";");
      $(picker).find(".caption")[0].innerHTML = name ;
      picker.setAttribute('data-selectedname', name);
      picker.setAttribute('title', name);
      var prev = $(picker).find("input[name=selectedName]");
      $(picker).find("input[name=selectedName]").val(name) ;
      $(picker).find("input[name=selectedHex]").val(hex);
      $(picker).find("input[name=prevName]").val(prev) ;
    };

    static remove_extension(s)
    {
      var i = s.indexOf('.') ;
      return (i > -1) ? s.substr(0, i) : s ;
    };

    static base64Encode(str) {
      var CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var out = "", i = 0, len = str.length, c1, c2, c3;
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          out += CHARS.charAt(c1 >> 2);
          out += CHARS.charAt((c1 & 0x3) << 4);
          out += "==";
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          out += CHARS.charAt(c1 >> 2);
          out += CHARS.charAt(((c1 & 0x3)<< 4) | ((c2 & 0xF0) >> 4));
          out += CHARS.charAt((c2 & 0xF) << 2);
          out += "=";
          break;
        }
        c3 = str.charCodeAt(i++);
        out += CHARS.charAt(c1 >> 2);
        out += CHARS.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += CHARS.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        out += CHARS.charAt(c3 & 0x3F);
      }
      return out;
  };
  static sanitize_GID(s)
  {

    if ( ( s !== null ) && ( s !== undefined) && ( s.length > 36 ) )
      return s.substring(s.length-36, s.length);
    else
      return s ;
  };
  static config_zoom_bar_update(v)
  {
    v = parseFloat(v);
    $('input[type="range"]').attr("max", ((v*2)&1)?(v*2):(v*2)-1);
    $('input[type="range"]').val(v);
    $('input[type="range"]').rangeslider('update', true);
  };
  static zoom_bar_set(v)
  {
    $('input[type="range"]').val(v);
    $('input[type="range"]').rangeslider('update', true);
  };

  static open_general_box(options, cb) {
    $.colorbox({closeButton:true, escKey:true,
      onLoad: function() {
        $('#cboxContent').addClass('round-modal');
      },
      onComplete: function() {
        if (cb) {
          cb();
        }
      },
      html:'<div class="info_modal ">'+
        '<div class="modal_heading "><span>'+options.heading+'</span></div>'+
          '<div class="modal_content">'+
          '<div class="infoPart"><p>'+options.content+'</p></div>'+
          '<div class="okayBtn">'+
            '<a class="whiteButton" onclick="$.colorbox.close();">No, Cancel</a>'+
            '<a id="'+options.target+'" class="orangeButton" onclick="$.colorbox.close();window.resetPatternBuilder();">Yes, Remove</a></div>'+
        '</div>'+
      '</div>' });
  }

  static is_mobile() {
    //return ($(window).width() < 768);
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  static get_thumb_from_canvas_base64() {
    var dataArray = window.AppInstance.instance().canvas.canvas().getContext("2d").getImageData(0, 0, 150, 150) ;
    var tempCanvas = document.createElement('canvas');
    tempCanvas.width = 150
    tempCanvas.height = 150
    tempCanvas.getContext('2d').putImageData(dataArray, 0, 0);
    return tempCanvas.toDataURL();
  }

  static open_color_box(href, cb, options, inMobile) {
    var colorboxOptions = {};
    var modalClass = "";
    let currScrollPos = 0;
    if (!$("#colorbox").is(":visible")) {
        currScrollPos = $(window).scrollTop();
    }

    if (typeof(options) == "boolean") {
        colorboxOptions.overlayClose = options;
    } else if (typeof(options) == "object") {
        for (var key in options) {
            colorboxOptions[key] = options[key];
        }
    }

    if (inMobile) {
        colorboxOptions.width ="100%";
        colorboxOptions.speed = 0;
        modalClass = "mobile";
        $('#cboxLoadingGraphic').remove();
        $('#cboxOverlay').addClass('mobile');
        $(window).scrollTop(0);
        $(window).scrollLeft(0);
    }

    if (typeof(colorboxOptions.showWrapper) == "undefined") {
        modalClass +=  " info-modal";
    }

    $.colorbox({
      className: modalClass,
      opacity: inMobile ? 1 : 0.6,
      inline: colorboxOptions.iframe ? false : true,
      width: colorboxOptions.width || false,
      height: colorboxOptions.height || false,
      href: href,
      iframe: colorboxOptions.iframe || false,
      overlayClose: colorboxOptions.overlayClose || false,
      escKey: colorboxOptions.overlayClose || false,
      speed: typeof(colorboxOptions.speed) == "undefined" ? 240 : colorboxOptions.speed,
      fadeOut: typeof(colorboxOptions.speed) == "undefined" ? 240 : colorboxOptions.speed,
      onLoad: function() {
        $('#cboxContent').addClass('round-modal');
      },
      onCleanup: function() {
        if (inMobile) {
          $(window).scrollTop(currScrollPos);
          currScrollPos = 0;
        }
      },
      onClosed: function() {
        if (typeof(colorboxOptions.onClosed) == "function") {
          colorboxOptions.onClosed();
        }
      },
      onComplete: function() {
        if (cb) {
          cb();
        }
      }
    });
  }
}